if(!window.theme._registeredSections['image-cards'] === true){
  theme.ImageCards = (function() {

    /**
     * Constructor
     */
    function ImageCards(container) {
      const sectionName = container.dataset.sectionName.replace('-', '_');
      const cards = container.querySelectorAll('.grid__item');
      if (!cards.length || !window.theme.observeElement) { return; }

      [...cards].forEach((card, index) => {
        window.theme.observeElement(card, () => {
          const blockSettings = JSON.parse(card.dataset.blockSettings || {});
          if (!Object.keys(blockSettings)) { return; }

          const creativeName = blockSettings.campaign_name;
          const ecommerce = {
            creative_name: creativeName,
            creative_slot: sectionName,
            promotion_id: `${creativeName} | ${sectionName}`,
            promotion_name: blockSettings.title,
          };

          const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
          const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
          window.pushEvent({
            event: 'view_promotion',
            menu_navigation_state: menuNavigationState,
            ecommerce,
          }, 'ecommerce');

          localStorage.setItem('ga4-promotionView', JSON.stringify(ecommerce));

          const links = card.querySelectorAll('a[href]');
          if (!links.length) { return; }

          links.forEach((link) => {
            link.addEventListener('click', () => {
              const menuNavigationClick = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
              const menuNavigationClickState = menuNavigationClick.menu_navigation_state || {};
              window.pushEvent({
                event: 'select_promotion',
                menu_navigation_state: menuNavigationClickState,
                ecommerce,
              }, 'ecommerce');
            });
          });
        });
      });
    }

    return ImageCards;
  })();
  window.theme.sections.register('image-cards', theme.ImageCards);
  window.theme._registeredSections['image-cards'] = true;
}
